import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import {
  BehaviorSubject, catchError, filter, from, map, Observable, shareReplay,
  switchMap, take, throwError, combineLatest
} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KbDataExtractionRequestService {


  private occEndPointService = inject(OccEndpointsService);
  private http = inject(HttpClient);
  currentComponent$ = new BehaviorSubject<any>(null);
  nextComponentClick$ = new BehaviorSubject<any>(false);

  dataExtractionOverviewDataCheckeBox$ = new BehaviorSubject<any>(null);
  customerData$ = new BehaviorSubject<any>(null);

  requestorData$ = new BehaviorSubject<any>(null);
  requestorDataCheckeBox$ = new BehaviorSubject<any>(null);

  reportEcuRecipient$ = new BehaviorSubject<any>(null);
  reportEcuRecipientCheckeBox$ = new BehaviorSubject<any>(null);

  vehicleInformationData$ = new BehaviorSubject<any>(null);
  ecuInformationData$ = new BehaviorSubject<FormData | null>(null);
  incidentformData$ = new BehaviorSubject<any>(null);


  returnShippingFormData$ = new BehaviorSubject<any>(null);
  private submitOnce$?: Observable<any>;
  constructor() { }

  setDataExtractionOverviewData(data: any) {
    this.dataExtractionOverviewDataCheckeBox$.next(data);
  }
  setCustomerData(data: any) {
    this.customerData$.next(data);
  }

  setRequestorData(data: any) {
    this.requestorData$.next(data);
  }
  setRequestorDataCheckbox(data: any) {
    this.requestorDataCheckeBox$.next(data);
  }

  setReportEcuRecipientData(data: any) {
    this.reportEcuRecipient$.next(data);
  }
  setreportEcuRecipientCheckbox(data: any) {
    this.reportEcuRecipientCheckeBox$.next(data);
  }

  setvehicleInformationData(data: any) {
    this.vehicleInformationData$.next(data);
  }

  setecuInformationData(data: FormData) {
    this.ecuInformationData$.next(data);
  }

  setincidentformData(data: any) {
    this.incidentformData$.next(data);
  }

  setReturnShippingFormData(data: any) {
    this.returnShippingFormData$.next(data);
  }


  /*  submitOnce(): Observable<any> {
     if (!this.submitOnce$) {
       this.submitOnce$ = combineLatest([
         this.customerData$,
         this.requestorData$,
         this.reportEcuRecipient$,
         this.vehicleInformationData$,
         this.ecuInformationData$,
         this.incidentformData$,
         this.returnShippingFormData$
       ]).pipe(
         // Capture one snapshot of the latest values when submit is triggered
         take(1),
         // Build the payload from the emitted form values
         map(([customer, requestor, reportEcu, vehicle, ecuForm, incident, returnShipping]) => ({
           customerVechicalForm: customer,
           requestorForm: requestor,
           reportEcuRecipientForm: reportEcu,
           vehicleForm: vehicle,
           ecuForm: ecuForm,
           incidentForm: incident,
           returnShippingform: returnShipping
         })),
         // Execute the HTTP POST with the composed payload
         switchMap(payload =>
           this.http.post<any>(this.occEndPointService.buildUrl('/dataExtraction/submit'), payload)
         ),
         // Cache & persist (won't tear down if subscribers unsubscribe)
         shareReplay({ bufferSize: 1, refCount: false })
       );
     }
     return this.submitOnce$;
   } */

  submitOnce(): Observable<any> {

    const buildMasterFormData = async (): Promise<FormData> => {
      const masterFd = new FormData();

      const isFormData = (x: any): x is FormData =>
        typeof FormData !== 'undefined' && x instanceof FormData;

      // ---- JSON sections (from BehaviorSubjects) ----
      const customer = this.customerData$.getValue() ?? {};
      const requestor = this.requestorData$.getValue() ?? {};
      const reportEcu = this.reportEcuRecipient$.getValue() ?? {};
      const vehicle = this.vehicleInformationData$.getValue() ?? {};
      const incident = this.incidentformData$.getValue() ?? {};
      const returnShipping = this.returnShippingFormData$.getValue() ?? {};

      // ---- ECU FormData (payload + files) ----
      const ecuData = this.ecuInformationData$.getValue();

      const safeParse = (s: string) => {
        try { return JSON.parse(s); } catch { return {}; }
      };

      // ---- Build ONE final JSON (ecuForm flattened) ----
      const finalJson: any = {
        customerVechicalForm: customer,
        requestorForm: requestor,
        reportEcuRecipientForm: reportEcu,
        vehicleForm: vehicle,
        incidentForm: incident,
        returnShippingform: returnShipping,
        ecuForm: {} // will be set from ecuData "payload"
      };

      // 1) Extract ECU payload (string) into finalJson.ecuForm (FLATTEN)
      // 2) Append ECU files to masterFd using SAME KEYS (bdrattachmentsInfoFiles, ecuFiles_0, ecuFiles_1)
      for (const [k, v] of ecuData.entries() as any) {

        // Flatten: ecuData has "payload" => put inside finalJson.ecuForm directly
        if (k === 'payload') {
          if (typeof v === 'string') {
            finalJson.ecuForm = safeParse(v);
          } else if (v instanceof Blob) {
            const text = await v.text();
            finalJson.ecuForm = safeParse(text);
          }
          continue;
        }

        // Files: keep keys EXACTLY as required
        if (v instanceof File) {
          // this will send: bdrattachmentsInfoFiles, ecuFiles_0, ecuFiles_1 ...
          masterFd.append(k, v, v.name);
        }
      }

      // Append ONE JSON part only
      masterFd.append('json', JSON.stringify(finalJson));

      // Debug dump
      console.log('----- MASTER_FORMDATA DUMP START -----');
      for (const [k, v] of masterFd.entries() as any) {
        if (v instanceof File) console.log(k, `File(name=${v.name}, size=${v.size}, type=${v.type})`);
        else console.log(k, v); // should only be "payload"
      }
      console.log('----- MASTER_FORMDATA DUMP END -----');

      return masterFd;
    };

    const url = this.occEndPointService.buildUrl('/dataExtraction/submit');

    if (!this.submitOnce$) {
      this.submitOnce$ = from(buildMasterFormData()).pipe(
        switchMap((fd) => this.http.post<any>(url, fd)),
        catchError((err) => {
          console.error('Submit failed:', err);
          return throwError(() => err);
        }),
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }

    return this.submitOnce$;
  }

  getVehicleDetails() {
    const url = this.occEndPointService.buildUrl('/dataExtraction/vehicleDetails');
    return this.http.get(url);
  }

}
